import { send } from "../api.js";

export interface BookingPaymentOverride {
  id: string;
  booking_id: number;
  reason: string;
  amount_waived: string;
  set_by_id: string;
  set_by_name: string;
  created_at: string;
}

export function setBookingPaymentOverride(appointmentId: number, bookingId: number, reason: string): Promise<BookingPaymentOverride> {
  return send("PUT", `/staff-api/api/v1/appointments/${appointmentId}/bookings/${bookingId}/payment-override`, { reason });
}

export function undoBookingPaymentOverride(appointmentId: number, override: BookingPaymentOverride, reason: string): Promise<void> {
  return send("POST", `/staff-api/api/v1/appointments/${appointmentId}/bookings/${override.booking_id}/payment-override/${encodeURIComponent(override.id)}/undo`, { reason });
}
